// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'user';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M5.063 4.5a3.937 3.937 0 1 0 7.874 0 3.937 3.937 0 0 0-7.874 0zM1.688 17.438a7.312 7.312 0 1 1 14.624 0'
  />
);

export const viewBox = '0 0 18 18';
